import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _regeneratorRuntime from "@babel/runtime/regenerator";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React, { useState, useCallback, useEffect, useRef, useMemo } from 'react';
import { useMutation } from '@apollo/client';
import { useToasts } from '@magento/peregrine';
import classes from './frequentlyListSelect.module.css';
import { ADD_PRODUCT_TO_REQUISITION_LIST, DELETE_REQUISITION_LIST_ITEMS } from 'src/pages/Account/FrequentlyOrderProducts/graphql/actions.gql.js';
import { CheckIcon, DownArrow, Button } from '../';
import { useOutsideAlerter } from './helper';

var FrequentlyListSelect = function FrequentlyListSelect(_ref) {
  var list = _ref.list,
      productSku = _ref.productSku,
      isSelectOpen = _ref.isSelectOpen,
      setIsSelectOpen = _ref.setIsSelectOpen,
      closeModal = _ref.closeModal;

  var _useState = useState([]),
      _useState2 = _slicedToArray(_useState, 2),
      selectListData = _useState2[0],
      setSelectListData = _useState2[1];

  var _useState3 = useState({
    added: [],
    removed: []
  }),
      _useState4 = _slicedToArray(_useState3, 2),
      frequentlyList = _useState4[0],
      setFrequentlyList = _useState4[1];

  var optionsRef = useRef();

  var _useToasts = useToasts(),
      _useToasts2 = _slicedToArray(_useToasts, 2),
      addToast = _useToasts2[1].addToast;

  var toast = function toast(text) {
    var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'success';
    return addToast({
      type: type,
      message: text,
      timeout: 5000
    });
  };

  useOutsideAlerter(optionsRef, setIsSelectOpen);

  var _useMutation = useMutation(ADD_PRODUCT_TO_REQUISITION_LIST),
      _useMutation2 = _slicedToArray(_useMutation, 1),
      addProductToRequisitionListMutation = _useMutation2[0];

  var _useMutation3 = useMutation(DELETE_REQUISITION_LIST_ITEMS),
      _useMutation4 = _slicedToArray(_useMutation3, 1),
      deleteProductFromReqListMutation = _useMutation4[0];

  useEffect(function () {
    if (list) setSelectListData(list === null || list === void 0 ? void 0 : list.map(function (item) {
      var _item$items;

      return _objectSpread({
        isCheck: (_item$items = item.items) === null || _item$items === void 0 ? void 0 : _item$items.items.some(function (item) {
          return item.product.sku === productSku;
        }),
        isLocalAdded: false
      }, item);
    }));
  }, [list]);

  var handleAddRemoveItem = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(data) {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              setFrequentlyList(function (prevState) {
                return {
                  added: prevState.added.filter(function (item) {
                    return item.uid !== data.uid;
                  }),
                  removed: prevState.removed.filter(function (item) {
                    return item.uid !== data.uid;
                  })
                };
              });

              if (data.isCheck && !data.isLocalAdded) {
                setFrequentlyList(function (prevState) {
                  return _objectSpread(_objectSpread({}, prevState), {}, {
                    removed: [].concat(_toConsumableArray(prevState.removed), [_objectSpread(_objectSpread({}, data), {}, {
                      isLocalAdded: false
                    })])
                  });
                });
              }

              if (!data.isCheck) {
                setFrequentlyList(function (prevState) {
                  return _objectSpread(_objectSpread({}, prevState), {}, {
                    added: [].concat(_toConsumableArray(prevState.added), [_objectSpread(_objectSpread({}, data), {}, {
                      isLocalAdded: true
                    })])
                  });
                });
              }

              setSelectListData(function (prevState) {
                return prevState.map(function (item) {
                  return item.uid === data.uid ? _objectSpread(_objectSpread({}, item), {}, {
                    isCheck: !item.isCheck,
                    isLocalAdded: !item.isLocalAdded
                  }) : _objectSpread({}, item);
                });
              });

            case 4:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function handleAddRemoveItem(_x) {
      return _ref2.apply(this, arguments);
    };
  }();

  var handleSubmit = function handleSubmit() {
    frequentlyList.removed.map( /*#__PURE__*/function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(item) {
        var _item$items2, _item$items2$items, _item$items2$items$fi;

        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return deleteProductFromReqListMutation({
                  variables: {
                    requisitionListUid: item.uid,
                    requisitionListItemUids: [item === null || item === void 0 ? void 0 : (_item$items2 = item.items) === null || _item$items2 === void 0 ? void 0 : (_item$items2$items = _item$items2.items) === null || _item$items2$items === void 0 ? void 0 : (_item$items2$items$fi = _item$items2$items.find(function (data) {
                      var _data$product;

                      return (data === null || data === void 0 ? void 0 : (_data$product = data.product) === null || _data$product === void 0 ? void 0 : _data$product.sku) === productSku;
                    })) === null || _item$items2$items$fi === void 0 ? void 0 : _item$items2$items$fi.uid]
                  }
                }).then(function () {
                  var _ref4, _frequentlyList$remov;

                  toast("Item has been successfully removed from ".concat((_ref4 = _toConsumableArray(frequentlyList === null || frequentlyList === void 0 ? void 0 : (_frequentlyList$remov = frequentlyList.removed) === null || _frequentlyList$remov === void 0 ? void 0 : _frequentlyList$remov.reduce(function (acc, curr) {
                    return [].concat(_toConsumableArray(acc), [curr === null || curr === void 0 ? void 0 : curr.name]);
                  }, []))) === null || _ref4 === void 0 ? void 0 : _ref4.join(',')));
                  setFrequentlyList(function (prevState) {
                    return _objectSpread(_objectSpread({}, prevState), {}, {
                      removed: []
                    });
                  });
                  closeModal();
                });

              case 2:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      return function (_x2) {
        return _ref3.apply(this, arguments);
      };
    }());
    frequentlyList.added.map( /*#__PURE__*/function () {
      var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(item) {
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return addProductToRequisitionListMutation({
                  variables: {
                    requisitionListUid: item.uid,
                    requisitionListItems: [{
                      sku: productSku,
                      quantity: 1
                    }]
                  }
                }).then(function () {
                  var _ref6, _frequentlyList$added;

                  toast("Item has been successfully added to ".concat((_ref6 = _toConsumableArray(frequentlyList === null || frequentlyList === void 0 ? void 0 : (_frequentlyList$added = frequentlyList.added) === null || _frequentlyList$added === void 0 ? void 0 : _frequentlyList$added.reduce(function (acc, curr) {
                    return [].concat(_toConsumableArray(acc), [curr === null || curr === void 0 ? void 0 : curr.name]);
                  }, []))) === null || _ref6 === void 0 ? void 0 : _ref6.join(',')));
                  setFrequentlyList(function (prevState) {
                    return _objectSpread(_objectSpread({}, prevState), {}, {
                      added: []
                    });
                  });
                  closeModal();
                });

              case 2:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));

      return function (_x3) {
        return _ref5.apply(this, arguments);
      };
    }());
  };

  var dropDownContent = selectListData === null || selectListData === void 0 ? void 0 : selectListData.map(function (item) {
    return React.createElement("li", {
      key: item.uid,
      className: classes.dropdownItem,
      onClick: function onClick() {
        return handleAddRemoveItem(item);
      }
    }, React.createElement("span", {
      className: item.isCheck ? classes.checkIconActive : classes.checkIcon
    }, item.isCheck && React.createElement(CheckIcon, null)), item.name);
  });
  var selectedLists = useMemo(function () {
    var lists = '';
    selectListData === null || selectListData === void 0 ? void 0 : selectListData.forEach(function (item) {
      if (item !== null && item !== void 0 && item.isCheck) {
        lists += (lists ? ', ' : '') + (item === null || item === void 0 ? void 0 : item.name);
      }
    });
    return lists;
  }, [selectListData]);
  var toggleSelectOpen = useCallback(function () {
    return setIsSelectOpen(function (prevState) {
      return !prevState;
    });
  });
  return React.createElement("div", {
    className: "flex flex-col items-center"
  }, React.createElement("div", {
    className: "relative w-full",
    ref: optionsRef
  }, React.createElement("div", {
    className: isSelectOpen ? classes.select : classes.selectNotActive,
    onClick: toggleSelectOpen
  }, selectedLists ? selectedLists : 'Select List', React.createElement("span", {
    className: isSelectOpen ? classes.downIconActive : classes.downIcon
  }, React.createElement(DownArrow, null))), isSelectOpen && React.createElement("ul", {
    className: classes.dropdown
  }, dropDownContent)), React.createElement(Button, {
    priority: "low",
    classes: {
      root: 'mt-7 uppercase'
    },
    onClick: handleSubmit,
    "aria-label": "Save Frequently list"
  }, "Save"));
};

export default FrequentlyListSelect;